export enum RestrictionStatusTextEnum {
    RESTRICTION_UNKNOWN = 'Unknown',
    RESTRICTION_CREATED = 'Created',
    RESTRICTION_REMOVED = 'Removed',
    RESTRICTION_PENDING_ACCEPTANCE = 'Pending Acceptance',
    RESTRICTION_PENDING_REVIEW = 'Pending Review',
    RESTRICTION_ACCEPTED = 'Accepted',
    RESTRICTION_APPROVED = 'Approved',
    RESTRICTION_BLOCKING = 'Blocking',
}